'use client'

import Link from 'next/link'
import { useSyncExternalStore } from 'react'
import { eventStatus, eventsForDisplay, type AppEvent } from './events'

const subscribe = () => () => {}

/**
 * Tells visitors when an event page is about a past event, and points them to
 * the next one. Status is computed in the browser so the page stays correct
 * after the end date without a rebuild. Renders nothing for live or upcoming
 * events, and nothing on the server (avoids a hydration mismatch).
 */
export default function EventStatusNotice({ event }: { event: AppEvent }) {
  // false during server render and hydration, true in the browser afterwards.
  const inBrowser = useSyncExternalStore(subscribe, () => true, () => false)
  if (!inBrowser || eventStatus(event) !== 'ended') return null
  const next = eventsForDisplay().find((e) => e.slug !== event.slug && eventStatus(e) !== 'ended') ?? null
  return (
    <div role="note" className="mb-5 rounded-xl border border-ink/10 bg-white px-4 py-3 text-sm text-gray-700">
      <strong className="text-ink">This event ended on {event.ends}.</strong>{' '}
      The app is still free to start, and everything below still works.
      {next ? (
        <>
          {' '}Next up:{' '}
          <Link href={`/events/${next.slug}`} className="font-semibold text-forest underline underline-offset-4">
            {next.name}
          </Link>
          , {next.starts}.
        </>
      ) : null}
    </div>
  )
}
